import { cn } from "@/lib/utils";

/**
 * Marqueur d'appartenance de page (variante B, 2026-07-31) : dit à qui
 * appartient une page de données quand elle n'a pas d'onglets de cockpit —
 * « Autopilote » (cyan) pour Analytique/Réglages, « commun » (gris) pour le
 * Journal. Règle : des onglets là où les deux mondes existent, un marqueur
 * sinon — jamais d'écran vide.
 */
export default function PageOwner({ variant }: { variant: "auto" | "common" }) {
  const auto = variant === "auto";
  return (
    <span
      className={cn(
        "inline-flex w-fit items-center gap-1.5 rounded-full border px-3 py-0.5 text-[11px] font-semibold",
        auto
          ? "border-accent-neon/45 bg-accent-neon/5 text-accent-neon"
          : "border-border-strong bg-card text-muted-foreground",
      )}
      data-testid={`page-owner-${variant}`}
    >
      <span className="size-1.5 rounded-full bg-current" aria-hidden />
      {auto ? "Autopilote" : "commun aux deux cockpits"}
    </span>
  );
}
